import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ngp-angular2-photoswipe',
  template: `
    <p>
      angular2-photoswipe works!
    </p>
  `,
  styles: []
})
export class Angular2PhotoswipeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
